export * from './dist/multiselect.component';



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular4-multiselect-dropdown/angular4-multiselect-dropdown.ts